module.exports = __webpack_public_path__ + "70eee4ddf711fa9691203ce564952608.svg";